import {ref} from 'vue';
import {useAxios} from "@/utils/axios";

const $axios = useAxios();

class Bucket {
    constructor(se, bucketName, dwldUrl, resizeUrl, projectId) {
        this.se = se;
        this.bucketName = bucketName;
        this.dwldUrl = dwldUrl;
        this.resizeUrl = resizeUrl;
        this.projectId = projectId;
    }

    /*
    * options: {
    *   imgResize: {
    *       is: false, // default : false, 업로드 파일 중 이미지 파일을 리사이즈 할 지 여부
    *       maxSize: 720 // default : 720, 조절사이즈 (720 / 1080)
    *   }
    * }
    * */
    async upld(file, options) {
        const flnm = file.name;
        const crtfcToken = await ncp.cmmn.getUpldCrtfcToken(this.se, flnm);
        const result = await ncp.cmmn.upld(file, this.bucketName, crtfcToken);
        let fileInfo = result;

        if (file.type.startsWith('image/') && options?.imgResize?.is) {
            let maxSize = 720;
            if (options.imgResize.maxSize) {
                maxSize = options.imgResize.maxSize;
            }
            const resizeResult = await this.resize(result.objectName, maxSize);
            resizeResult.orgnFlnm = result.orgnFlnm;
            fileInfo = resizeResult;
        }

        return fileInfo;
    }

    async uplds(files, options) {
        const results = [];
        const MAX_CONCURRENT_UPLOADS = 5;
        const fileChunks = [];

        const filesArray = Array.from(files);

        for (let i = 0; i < filesArray.length; i += MAX_CONCURRENT_UPLOADS) {
            fileChunks.push(filesArray.slice(i, i + MAX_CONCURRENT_UPLOADS));
        }

        for (const chunk of fileChunks) {
            const chunkResults = await Promise.all(chunk.map(file => this.upld(file, options)));
            results.push(...chunkResults);
        }

        return results;

    }

    async dwld(objectName, dwldFlnm) {
        const dwldUrl = await this.getDwldUrl(objectName);
        const config = {
            responseType: 'blob',
            headers: { 'Content-Type': 'application/json;charset=utf-8;' },
        };

        const res = await $axios.get(dwldUrl, config);

        const blobParts = [res.data];
        const blobOptions = { type: res.headers['content-type'] };
        const blob = new Blob(blobParts, blobOptions);

        const objectURL = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = objectURL;
        if (dwldFlnm) {
            link.setAttribute('download', dwldFlnm);
        } else {
            link.setAttribute('download', objectName.substring(objectName.lastIndexOf('/')+1));
        }
        document.body.appendChild(link);
        link.click();
        link.remove();
    }

    async getDwldUrl(objectName) {
        const crtfcToken = await ncp.cmmn.getDwldCrtfcToken(this.se, objectName);
        return this.dwldUrl + '/' + objectName + '?crtfctoken=' + encodeURIComponent(crtfcToken);
    }

    async resize(objectName, maxSize) {
        const dwldUrl = this.getResizeUrl(objectName, maxSize);
        const config = {
            responseType: 'blob',
        };
        const res = await $axios.get(dwldUrl, config);

        const fileBlob = res.data;
        // Blob을 File 객체로 변환 (optional, for better compatibility)
        const fileNm = objectName.substring(objectName.lastIndexOf('/')+1);
        const file = new File([fileBlob], fileNm, { type: fileBlob.type });
        return await this.upld(file);
    }

    getResizeUrl(objectName, maxSize) {
        const projectId = ncp[this.se].projectId;
        const parameter = 'type=m' +
          '&w=' + maxSize +
          '&h=' + maxSize+
          '&quality=100';
        return this.resizeUrl + '/' + projectId + '/' + objectName + '?' + parameter;
    }
}

const ncp = {
    cmmn: {
        upld: async (file, bucketName, crtfcToken) => {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('bucketName', bucketName);
            formData.append('crtfcToken', crtfcToken);

            const res = await $axios.post('/api/file/upld', formData);
            return res.data;
        },
        getUpldCrtfcToken: async (se, flnm) => {
            const params = {
                flnm,
            }
            const url = '/api/file/' + se + '-upld-crtfc-token';
            const res= await $axios.get(url, {params});
            return res.data;
        },
        getDwldCrtfcToken: async (se, objectName) => {
            const params = {
                objectName,
            }
            const url = '/api/file/' + se + '-dwld-crtfc-token';
            const res= await $axios.get(url, {params});
            return res.data;
        },
        createAllBucket: async () => {
            const createBucket = ncp.cmmn.createBucket;
            await Promise.all([
                createBucket('tcfl'),
                createBucket('tmp')
            ]);
        },
        createBucket: async (bucketSe) => {
            const res = await $axios.get('/api/file/' + bucketSe + '-bucket');
            const bucket = res.data;
            ncp[bucketSe] = new Bucket(
              bucketSe,
              bucket.bucketName,
              bucket.dwldUrl,
              bucket.resizeUrl,
              bucket.resizeProjectId,
            );
        }
    },
    tmp: null,
    tcfl: null,
};

const getExtsnByFileNm = (fileNm) => {
    let extsn = '';
    const idx = fileNm.lastIndexOf('.');
    if (idx > -1) extsn = fileNm.substring(idx+1).toLowerCase();

    return extsn;
}

// todo 다시 손봐야함...
const extsnClasses = ref([
    {extsn: 'bmp', class: 'bmp'},
    {extsn: 'jpg', class: 'jpg'},
    {extsn: 'jpeg', class: 'jpg'},
    {extsn: 'gif', class: 'gif'},
    {extsn: 'png', class: 'png'},
    {extsn: 'zip', class: 'zip'},
    {extsn: 'hwp', class: 'hwp'},
    {extsn: 'ppt', class: 'ppt'},
    {extsn: 'pptx', class: 'ppt'},
    {extsn: 'xls', class: 'xls'},
    {extsn: 'xlsx', class: 'xls'},
    {extsn: 'doc', class: 'doc'},
    {extsn: 'docx', class: 'doc'},
    {extsn: 'pdf', class: 'pdf'},
    {extsn: 'etc', class: 'etc'},
]);

const getExtsnClassByExtsn = (extsn) => {
    if(!extsn) extsn = 'etc';

    const extsnClassInfo = extsnClasses.value.find((element) => element.extsn == extsn);

    let extsnClass = '';

    if(extsnClassInfo) extsnClass = 'icon-' + extsnClassInfo.class;
    else extsnClass = 'icon-etc';

    return extsnClass;
}

const getFileSize = (size) => {
    let setFileSize = '';

    if (size < 1024) setFileSize = size + 'byte';
    else if (size >= 1024 && size < (1024 * 1024)) setFileSize = Math.round(size / 1024) + 'KB';
    else if (size >= (1024 * 1024) && size < (1024 * 1024 * 1024)) setFileSize = Math.round(size / 1024 / 1024) + 'MB';
    else if (size >= (1024 * 1024 * 1024)) setFileSize = Math.round(size / 1024 / 1024 / 1024) + 'GB';

    return setFileSize;
}

const getFileByFileSn = async (fileSn) => {
    const {data} = await $axios.get('/api/file/by-file-sn', {params: {fileSn}});
    return data;
}

const useFile = () => {
    return {
        ncp,
        getExtsnByFileNm,
        getExtsnClassByExtsn,
        getFileSize,
        getFileByFileSn
    }
}

export { useFile };
